import { startTransition, useState } from 'react';
import { useTranslations } from 'next-intl';
import { analytics, Calendar } from '@silvertours/front-entities';
import { useSearchContext } from '../SearchFormLegacy/context';
import { SceneProps, WizardOverlay } from './common';
import { getDays } from './datetime';

const CalendarScene = ({ onConfirm, ...props }: SceneProps) => {
  const { state, setDate: setDateInSearchContext } = useSearchContext();
  const [dates, setDates] = useState({
    dep: state?.depDate ? new Date(state.depDate) : new Date(),
    dest: state?.destDate ? new Date(state.destDate) : new Date(),
  });
  const depDate = dates.dep;
  const destDate = dates.dest;

  const t = useTranslations('features.stage.search');

  if (!state) {
    return null;
  }

  const dayCountText = t('calendar.dayCount', {
    days: getDays(depDate, destDate),
  });

  const handleDatesConfirm = () => {
    analytics.generic.trackDateRangeConfirmSelectionClick(depDate, destDate);
    startTransition(() => {
      setDateInSearchContext('departure', depDate);
      setDateInSearchContext('destination', destDate);
      onConfirm();
    });
    analytics.gtm.trackConfirmDates();
  };

  const invalid = destDate <= depDate;

  return (
    <WizardOverlay
      {...props}
      onConfirm={handleDatesConfirm}
      title={t('calendar.headline')}
      buttonText={dayCountText}
      buttonDisabled={invalid}
    >
      {/* Clarity unmask (LPOT-1716): the wizard's calendar grid, for analytics. */}
      <div data-clarity-unmask="true">
        <Calendar
          from={depDate}
          to={destDate}
          hasManuallySetTimes={false}
          onChange={d => {
            setDates({
              dep: d.from!,
              dest: d.to!,
            });
            // Deferred (LPOT-792): in production dataLayer.push() runs GTM
            // tags synchronously, including Clarity's DOM scan over this
            // unmasked grid — inside the click handler that pushes past
            // 200ms INP on every day selection. Scheduling it for its own
            // task lets the browser paint the selection first.
            setTimeout(() => analytics.gtm.trackSelectDates(), 0);
          }}
          vertical
        />
      </div>
    </WizardOverlay>
  );
};

export { CalendarScene };
